let modalOpen = false;
let keyDown = false;

function changeBgColor(color) {
    const root = document.querySelector(":root");
    root.style.setProperty("--bg-color", color);
}

function sortArray(arr) {
    const newArray = [ ...arr ];

    newArray.sort(function(a, b) {
        return b.value - a.value;
    });

    return newArray;
}

function toGroups(arr) {
    const groups = [[], [], [], []];

    for(let i = 0; i < arr.length; i++) {
        let { group } = arr[i];

        groups[group - 1].push(arr[i]);
    }

    return groups;
}

function Tooltip(x, y, text) {

    const width = document.body.clientWidth;

    console.log(width, typeof width);
    console.log(x);
    const treshold = 150;

    this.div = document.createElement("div");
    this.div.id = "div-" + new Date().getTime();
    this.mounted = false;
    this.x = x;
    this.y = y;
    
    this.div.style.cssText = `
        position: fixed;
        left: ${this.x + 5}px;
        top: ${this.y}px;
        ${ this.x > width - treshold ? 
           "transform: translateX(-115%);"
           :
           "transform: translateX(0);"
        }
        width: fit-content;
        height: 2.5rem;
        padding: 0 .8rem;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.65);
        color: #fff;
        text-align: center;
        line-height: 2.5rem;
        z-index: 5000;
    `;

    this.div.textContent = text;

    this.mount = function () {
        if(!this.mounted) {
            document.body.appendChild(this.div);
            this.mounted = true;
        }
    }

    this.unMount = function() {
        if(document.getElementById(this.div.id)) document.body.removeChild(this.div);
    }

    this.setText = function(newText) {
        this.div.textContent = newText;
        this.mount();
    }
}

function cssListener() {

    let tooltip;

    document.addEventListener("click", e => { 
        if(tooltip) tooltip.unMount();

        showStyles(e);
    });

    document.addEventListener("mouseover", function(e) {
        
        if(!keyDown) return;

        const { tagName } = e.target;
        const { clientX, clientY } = e;

        tooltip = new Tooltip(clientX, clientY, tagName);
        tooltip.mount();
    });

    document.addEventListener("mouseout", function(e) {
        if(tooltip) tooltip.unMount();
    });
    
    document.addEventListener("keydown", function(e) {
        keyDown = e.ctrlKey;
    });

    document.addEventListener("keyup", function(e) {
        keyDown = e.ctrlKey;

        if(tooltip) tooltip.unMount();
    });
}

function ResultsTable(data) {
    const table = document.createElement("table");
    let tbody = document.createElement("tbody");
    let thead = document.createElement("thead");
    let tr = document.createElement("tr");

    tbody.id = "table-body";

    tr.innerHTML = `
        <th>Ominaisuus</th>
        <th>Arvo</th>
    `;

    thead.appendChild(tr);
    
    table.classList.add("table");
    table.appendChild(thead);

    let index = 0;
    let val;

    for(const prop in data) {
        
        // if(index === 30) break;
        
        val = data[prop];

        if(val.value) {
            let value = val.value;
            if(val.unit) value += " (type: " + val.unit + ")";

            tr = document.createElement("tr");
            tr.innerHTML = `
                <td>${prop}</td>
                <td>${value}</td>
            `;
            tbody.appendChild(tr);
        }
        index++;
    }   

    table.appendChild(tbody);
    return table;
}

function filterResults(searchString, data) {
    let result = {};

    for(const prop in data) {

        if(prop.includes(searchString)) {
            result[prop] = data[prop];
        }
    }   

    return result;
}

function createModalElements(data, title = "Otsikko", label = "Hae nimellä", btnText = "Hae") {
    
    const modal = document.createElement("div");
    const heading = document.createElement("h2");
    const classP = document.createElement("p");
    const searchField = document.createElement("input");
    const searchBtn = document.createElement("button");
    let table = ResultsTable(data.styles);
    const closeBtn = document.createElement("button");

    const inputClasses = ["pr-12", "input", "input-primary", "input-bordered"];
    const searchButtonClasses = ["absolute", "rounded-l-none", "btn", "btn-primary"];

    modal.classList.add("my-modal");
    modal.id = "css-modal";
    heading.textContent = title;
    classP.innerHTML = "<b>luokat:</b> " + data.classes;
    classP.classList.add("class-p");

    table.id = "data-table";
    
    searchField.placeholder = "Hae ominaisuuksia";
    searchField.classList.add(...inputClasses);
    
    searchBtn.textContent = btnText;
    searchBtn.classList.add(...searchButtonClasses);
    
    searchBtn.addEventListener("click", function() {
        const { value } = searchField;

        if(value.length && value.length > 0) {
            const results = filterResults(value, data.styles);
            
            table = ResultsTable(results);
            const tbody = table.querySelector("#table-body");

            document.getElementById("table-body").innerHTML = tbody.innerHTML;
        }
    }, false);

    closeBtn.textContent = "x";
    closeBtn.classList.add("close-btn");

    closeBtn.addEventListener("click", function() {
        document.body.removeChild(document.getElementById("css-modal"));
        modalOpen = false;
        cssListener();
    });

    modal.appendChild(heading);
    modal.appendChild(classP);
    modal.appendChild(searchField);
    modal.appendChild(searchBtn);
    modal.appendChild(table);
    modal.appendChild(closeBtn);


    return modal;
}

function render(root, elements) {
    root.appendChild(elements); 
}


function Modal(root, data) {
    
    const { name, classes, styles } = data;
    const modal = createModalElements(data, "Elementti: " + name);

    render(root, modal);

    modalOpen = true;
    document.removeEventListener("click", showStyles);
}

function showStyles(e) {

    if(modalOpen || !keyDown) return;

    const { name, classes, styles } = getStyles(e);

    Modal(document.body, { name, classes, styles });
}

function getStyles(e) {

    const styles = e.target.computedStyleMap();
    const styleObj = {};
    const classList = e.target.classList;
    let classes = "";
    let styleString = "";

    for (const [prop, val] of styles) {
        styleString += prop + " : " + val + "\n";
        
        if(val[0]) styleObj[prop] = val[0];
    }

    let index = 0;

    for(let c of classList) {
        if(index < classList.length - 1) classes += c + ", ";
        else classes += c;
        
        index++;
    }

    return { name: e.target.tagName, classes: classes, styles: styleObj }
}

function emptyAllQuestions(quests) {
    const questions = [];

    for(let i = 0; i < quests.length; i++) {
        quests[i].value = 0;
        questions.push(quests[i]);
    }

    return questions;
}

function getLangParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if(params.lang) {
        if(params.lang === "en" || params.lang === "fi") return params.lang;
        else return null;
    }
    else {
        return null;
    }
}

function isFirstVisit() {
    const isFirst = localStorage.getItem("firstVisit");

    if(!isFirst) {
        localStorage.setItem("firstVisit", "" + new Date().getTime());
        return true;
    }
    else {
        return false;
    }
}

function clearFirstVisit() {
    localStorage.removeItem("firstVisit");
}

export { changeBgColor, sortArray, toGroups, cssListener, emptyAllQuestions, isFirstVisit, clearFirstVisit, getLangParams }